var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.78,
    height: 38.78,
    fill: "#272727"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 18.8919L9.64264 16.2492M9.64264 16.2492L18.8919 7L28.1411 16.2492M9.64264 16.2492V29.4625C9.64264 30.1922 10.2342 30.7838 10.964 30.7838H14.9279M28.1411 16.2492L30.7838 18.8919M28.1411 16.2492V29.4625C28.1411 30.1922 27.5496 30.7838 26.8198 30.7838H22.8559M14.9279 30.7838C15.6577 30.7838 16.2492 30.1922 16.2492 29.4625V24.1772C16.2492 23.4474 16.8408 22.8559 17.5706 22.8559H20.2132C20.943 22.8559 21.5345 23.4474 21.5345 24.1772V29.4625C21.5345 30.1922 22.1261 30.7838 22.8559 30.7838M14.9279 30.7838H22.8559",
    stroke: "#F9F9F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1a4a1d73893b7e78acc700b7c9dbdc20.svg";
export { ForwardRef as ReactComponent };